module.exports = __webpack_public_path__ + "static/img/5-CN-old.4b5d30d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/5-CN-old.png
// module id = rtnt
// module chunks = 1